import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PreferencesService } from '../services/preferences.service';
import { LocalStorageService } from '../services/localstorage.service';
import { SearchHistoryComponent } from '../pages/searches/search-history.component';
import { SearchHistoryService } from '../services/search-history.service';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html'
})
export class NavigationComponent implements OnInit {
  @Input()
  public showLanguageChooser: boolean;
  constructor(private preferenceService: PreferencesService, 
    private router:Router,
    private storage: SearchHistoryService) { }

  ngOnInit() {
  }
  
  changeLanguage(code: string) {
    this.preferenceService.languageCode = code;
    this.preferenceService.needsReload=true;
   
     // call clearStorage
     this.storage.clearSearchResults("foliar");
     this.storage.clearSearchResults("seed");

    this.router.navigateByUrl('');
  }
}
